import React from 'react';
import RestaurantItemWrapper from './Restaurantitem.styles';
import IntlMessages from '@iso/components/utility/intlMessages';
import bigClosedIcon from '@iso/assets/images/localeats/restaurant/big-closed-icon.png';
import smallClosedIcon from '@iso/assets/images/localeats/restaurant/small-closed-icon.png';
import timeIcon from '@iso/assets/images/localeats/restaurant/time-icon.png';
import deliveryIcon from '@iso/assets/images/localeats/restaurant/delivery-icon.png';
import pickUpIcon from '@iso/assets/images/localeats/restaurant/pick-up-icon.png';
import DumyLogo from '@iso/assets/images/dumy.png';
import Award from '@iso/assets/images/award.png';

const RestaurantItem = ({
  index,
  path,
  mainImg,
  smallImg,
  name,
  shortDescription,
  description,
  view,
  closed,
  isWork,
  deliveryMethod,
  time,
  cost,
}) => {
  const descriptionText = shortDescription?.map((item, index) => {
    if (index + 1 === shortDescription.length) {
      return (
        <span key={index}>
          <IntlMessages id={item.name} />
        </span>
      );
    }
    return (
      <span key={index}>
        <IntlMessages id={`${item.name}`} />
        {' · '}
      </span>
    );
  });

  function getPrice(cost) {
    let res = '';
    for (let i = 0; i < cost; i++) {
      res += '$';
    }
    return res;
  }

  const validNames = [
    "Peppino's Pizzeria",
    'Varsity Pizza',
    'Trattorio Abbiocco',
    'West End Kitchen and Catering',
    'Pavones Pizza',
    'East Of Chicago',
    'Tangy Tomato',
    'Mario & Salvos',
    'Apizza Regionale',
    "Cardano's Pizza & Wings",
    'Daniela. ',
    'Mister Submarine',
    'Broadway Bobbys Pizzeria',
    'Ricottas Pizza Niagara',
    'Desis Pizzeria',
    'Maybacks Pizza & Subs',
    'La Nova',
    'Wise Guys Pizza',
    'Sisters & Sons Pizzeria & Deli',
    'Mustachios Pizzeria',
    'La Quinta Pizza',
    'Krusti Pizza & Pasta',
    'A Slice of New York',
    'Desi Pizza house',
    'Slice of Homage Pizza',
    'Via Mia Pizza',
    'Pizza Presidente',
    'Bibos NY Pizza',
    'Tasty Pizza Indian & Italia',
    'Ciceros Pizza',
  ];

  return (
    <>
      <RestaurantItemWrapper
        className="restaurant-item"
        style={{
          boxShadow: '0 4px 14px rgba(19, 77, 127, 0.16)',
        }}
      >
        <a target="_blank" rel="noopener noreferrer" href={path}>
          <div className={view}>
            <div className="image-block">
              {/* {view === 'view2' && (
     <div className="product-image" style={{width: '200px', height: '200px', position: 'fixed'}}>
       <img src={mainImg} alt={name} className="main-img" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
     </div>
   )} */}

              {/* <div className="product-image" style={{width: '200px', height: '200px', position: 'fixed'}}>
       <img src={mainImg} alt={name} className="main-img" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
     </div> */}
              <div className="product-image">
                <img
                  src={mainImg === '' ? DumyLogo : mainImg}
                  alt={name}
                  className="main-img"
                />
              </div>

              {/* closed logic */}
              {!isWork && closed && view === 'view1' && (
                <div className="closed-restaurant-1">
                  <img src={smallClosedIcon} alt="Closed" />
                </div>
              )}
              {!isWork && closed && view === 'view2' && (
                <div className="closed-restaurant-2">
                  <img src={smallClosedIcon} alt="Closed" />
                </div>
              )}
              {!isWork && closed && view === 'view3' && (
                <div className="closed-restaurant-3">
                  <img src={bigClosedIcon} alt="Closed" />
                </div>
              )}

              {view === 'view3' && (
                <div className="small-img-block">
                  <img
                    className="small-img"
                    src={smallImg === '' ? DumyLogo : smallImg}
                    alt={name}
                  />
                </div>
              )}
              {view === 'view3' && validNames.includes(name) ? (
                <div className="small-img-block-award">
                  <img className="small-img" src={Award} alt={Award} />
                </div>
              ) : null}
            </div>
            <div className="text-block">
              <p className="restaurant-name">{name}</p>
              <p className="restaurant-description-short">
                {descriptionText && descriptionText}
              </p>

              <div className="restaurant-parameters">
                <p>
                  <img src={timeIcon} alt="time" />
                  &nbsp;
                  {time}
                </p>
                {deliveryMethod.indexOf('Courier') !== -1 ? (
                  <p>
                    <img src={deliveryIcon} alt="Delivery" />
                    &nbsp; Delivery
                  </p>
                ) : null}
                {deliveryMethod.indexOf('Take-away') !== -1 ? (
                  <p>
                    <img src={pickUpIcon} alt="Pick-up" />
                    &nbsp; Pickup
                  </p>
                ) : null}

                <p className="restaurant-price">{getPrice(cost)}</p>
              </div>

              {view === 'view3' && (
                <p className="restaurant-description">{description}</p>
              )}
            </div>
          </div>
        </a>
      </RestaurantItemWrapper>
    </>
  );
};

export default RestaurantItem;
